import { useEffect, useState } from 'react'
import { classNames } from 'utils/dom-helpers'
import DialogModal from './Dialog'
export interface IErrorModal {
    error_message: string,
    error_title?:string,
    onCloseModal: () => void,
    type?: "success" | "error" | "warning",
    tag?: string,
    button_message?: string,
    show?:boolean,
}
const ErrorModal = ({
    error_message,
    onCloseModal,
    type = 'error',
    button_message,
    error_title,
    show = true
}: IErrorModal) => {
    const [showModal, setShowModal] = useState<boolean>(show)

    useEffect(()=>{
        setShowModal(show)
    },[show])

    const content = (
        <div
            style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
            }}
        >
            
            <i
                className={classNames(
                    'text-xl  text-white rounded-full p-2 mt-4 mb-4',
                        type === 'success' ? 'feather-check-circle bg-green-500':
                        type === 'error' ? 'feather-alert-triangle bg-red-500':
                        type === 'warning' ? 'feather-alert-triangle text-center w-10 h-10 bg-yellow-500':
                    ''
                )}
            />
            {error_title && (
                <p className='text-3xl text-[#23476B]  text-center font-bold my-6'>
                    { error_title }
                </p>
            )}
            <p style={{ textAlign: 'center' }} dangerouslySetInnerHTML={{__html:error_message}}></p>
        </div>
    )
    return (
        <>
        {
            showModal && (
                <DialogModal
                    prompt_message={content}
                    onCloseModal={onCloseModal}
                    button_position="center"
                    button_message={ button_message }
                />
            )}
        </>    
    )
}

export default ErrorModal
